import { SET_LOGIN_TOKEN } from "uniba-volto-jwtsession/actions";
import userSession from "uniba-volto-manutenzione/customizations/volto/reducers/userSession/userSession.js"

const initialState = {
    token: null,
    login: {
        loaded: false,
        loading: false,
        error: null,
    },
};

/**
 * login Token reducer.
 * @function loginTokenReducer
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export function loginTokenReducer(state = initialState, action = {}) {
    if (action.type === SET_LOGIN_TOKEN) {
        return {
            ...state,
            token: action.result.token,
        };
    }
    // Tutte le altre action passano al reducer originale
    return userSession(state, action);
};
